import styled from 'styled-components';
import { BodyStyles } from '../Text/Body';

export const Container = styled(BodyStyles)`
  height: 50px;
  width: 100%;
  min-height: 45px;
  max-height: 50px;
  max-width: 335px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-radius: 2px;
  position: relative;
  background-color: ${props => props.theme['text-field-background']};;
  input {
    line-height: inherit;
    letter-spacing: inherit;
    font-size: inherit;
    left: 20px;
    position: absolute;
    top: calc(50% - 24px / 2 + 6px);
    background-color: transparent;
    width: calc(100% - 30px);
    padding: 0 1px;
    ::placeholder {
    }
    @supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */
    top: -webkit-calc(50% - 24px / 2 + 6px);
    width: -webkit-calc(100% - 30px);
  }
  }
  @media screen and (max-width: 500px) {
    max-width: unset;
  }
`;

export const Label = styled.label`
  @supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */ 
    top: ${props => (props.active ? '-webkit-calc(50% - 15px/2 - 10.5px);' : '12px')};
  }
  z-index: 1;
  -webkit-appearance: none;
  transition: all 0.1s ease-in-out;
  font-family: ${props =>
    props.active ? 'PublicSans-Light' : 'PublicSans-Regular'};
  font-size: ${props => (props.active ? '12px' : '15px')};
  color: ${props => props.theme['text-color']};
  line-height: ${props => (props.active ? '12px' : '24px')};
  position: absolute;
  top: ${props => (props.active ? 'calc(50% - 15px/2 - 10.5px);' : '12px')};
  left: 20px;
  pointer-events: none;
`;


export const HidePasswordButton = styled.img`
  width: 15px;
  height: auto;
  object-fit: contain;
  cursor: pointer;
`;

export const ToolTipIcon = styled.img`
  height: 12px;
  width: 12px;
  padding: 5px;
  border: 1px solid #7B7B80;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
`;

export const ToolTipModal = styled.div`
  width: 335px;
`;

export const ToolTipBody = styled.div`
  width: 335px;
`;
export const ToolTipTitle = styled.div`
  width: 335px;
`;